// extracted by mini-css-extract-plugin
export default {"banner_add":"Home_banner_add__-2Mdd","card_list_title":"Home_card_list_title__iPvqp","Flickity":"Home_Flickity__qjNKp"};